module.exports = __webpack_public_path__ + "static/media/27.4236dde4.jpg";